/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientEmployeeAppUsageCountQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['UUID']['input'];
  dateFrom?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  dateTo?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type ClientEmployeeAppUsageCountQuery = { __typename: 'Query', clientEmployeeApplicationInteractions?: { __typename: 'ClientEmployeeApplicationInteractionsResultType', totalCount: number } | null };



export const ClientEmployeeAppUsageCountDocument = `
    query ClientEmployeeAppUsageCount($employeeId: UUID!, $dateFrom: Date, $dateTo: Date) {
  clientEmployeeApplicationInteractions(
    clientEmployeeId: $employeeId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    totalCount
  }
}
    `;

export const useClientEmployeeAppUsageCountQuery = <
      TData = ClientEmployeeAppUsageCountQuery,
      TError = unknown
    >(
      variables: ClientEmployeeAppUsageCountQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeeAppUsageCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeeAppUsageCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeeAppUsageCountQuery, TError, TData>(
      {
    queryKey: ['ClientEmployeeAppUsageCount', variables],
    queryFn: fetcher<ClientEmployeeAppUsageCountQuery, ClientEmployeeAppUsageCountQueryVariables>(ClientEmployeeAppUsageCountDocument, variables),
    ...options
  }
    )};

useClientEmployeeAppUsageCountQuery.getKey = (variables: ClientEmployeeAppUsageCountQueryVariables) => ['ClientEmployeeAppUsageCount', variables];

export const useInfiniteClientEmployeeAppUsageCountQuery = <
      TData = InfiniteData<ClientEmployeeAppUsageCountQuery>,
      TError = unknown
    >(
      variables: ClientEmployeeAppUsageCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeeAppUsageCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeeAppUsageCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeeAppUsageCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientEmployeeAppUsageCount.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeeAppUsageCountQuery, ClientEmployeeAppUsageCountQueryVariables>(ClientEmployeeAppUsageCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeeAppUsageCountQuery.getKey = (variables: ClientEmployeeAppUsageCountQueryVariables) => ['ClientEmployeeAppUsageCount.infinite', variables];


useClientEmployeeAppUsageCountQuery.fetcher = (variables: ClientEmployeeAppUsageCountQueryVariables) => fetcher<ClientEmployeeAppUsageCountQuery, ClientEmployeeAppUsageCountQueryVariables>(ClientEmployeeAppUsageCountDocument, variables);
